import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import { SActionBtn, SFuncModal, SIDRender, SLowcodeList, STableActions } from 'shj-components'
import config from './config'
import { TabComponentInterface } from '../../../index.d'
import { useNavigate, useParams } from 'react-router-dom'
import { getAudioRecordPageByCustomerId } from '@/services/crmTool.ts'

const Clue = forwardRef<TabComponentInterface>((_, ref) => {
  const { id } = useParams()
  const navigate = useNavigate()
  const listRef = useRef<any>()
  const microAppData = window?.microApp?.getData?.()
  
  // 暴露设置列弹窗的打开方法
  useImperativeHandle(ref, () => ({
    openSettingModal: () => {
      listRef.current?.openSetting?.()
    },
  }))

  const fetchList = (values: any) => {
    return new Promise( (resolve, reject) => {
      try {
        const { current = 1, pageSize = 10, query = {} } = values
        const data = { ...query, orderBys: [{columnName: 'created_time', asc: false}] }
        const _param = { ...data,customerId:id }
        getAudioRecordPageByCustomerId({params: {pageId: current, pageSize,..._param}})
          .then((_records: any) => {
            resolve({ records: _records?.list || [], total: _records?.count || 0 })
          })
          .finally(() => {
            reject({ success: false })
          })
      } catch (e) {
        reject({ success: false })
      }
    })
  }
// 简易弹窗
  const onPlay = (data: Record<string, any>) => {
    SFuncModal({
      width: 400,
      title: '播放',
      vanish: true,
      content: (
        <div style={{textAlign: 'center', padding: '10px 0'}}>
          <audio src={data?.ossUrl} controls>
            浏览器不支持音频播放。
          </audio>
        </div>
      ),
    })
  }
  const extension = {
    request: { fetchList },
    events: {},
    // auth: authMap,
    status: {},
    customRender: {
      // 线索ID渲染
      clueIdRender(text: string, record: Record<string, any>) {
        const returnUrl = `/CrmPlus/customerProfileDetail/${id}`;
        return (
          <SIDRender
            id={text}
            onClick={() => microAppData.pushState(`/mos/saleOp/salesWorkBench/salesWorkBenchDetail/${record?.clueId}&returnUrl=${returnUrl}`)}
          />
        )
      },
      operation(text: any, record: any) {
        if(!record?.ossUrl)return null;
        return (
          <STableActions>
            <SActionBtn
              onClick={() => {
                onPlay(record)
              }}
            >
              播放
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }

  return (
    <>
      <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} />
    </>
  )
})

export default Clue
